import { createSlice } from "@reduxjs/toolkit";
import {
  getFuel,
} from "./fuelService";

/* -------------------- Status Enum -------------------- */

export const STATUS = {
  IDLE: "idle",
  LOADING: "loading",
  SUCCEEDED: "succeeded",
  FAILED: "failed",
};

/* -------------------- Initial State -------------------- */

const initialState = {
  fuelList: {
    status: STATUS.IDLE,
    error: null,
    data: [],
  },
};

/* -------------------- Slice -------------------- */

const fuelSlice = createSlice({
  name: "fuel",
  initialState,
  reducers: {},
  extraReducers: (builder) => {

    /* ---------- Get Fuel List ---------- */
    builder
      .addCase(getFuel.pending, (state) => {
        state.fuelList.status = STATUS.LOADING;
        state.fuelList.error = null;
      })
      .addCase(getFuel.fulfilled, (state, action) => {
        state.fuelList.status = STATUS.SUCCEEDED;
        state.fuelList.data = action?.payload?.data || [];
      })
      .addCase(getFuel.rejected, (state, action) => {
        state.fuelList.status = STATUS.FAILED;
        state.fuelList.error = action.payload?.message;
      });

  },
});

/* -------------------- Selectors -------------------- */

export const selectFuelList = (state) =>
  state.fuel.fuelList;

export default fuelSlice.reducer;
